import { gql, useLazyQuery } from "@apollo/client";
import Button from "components/base/Button";
import { FileSelector } from "components/base/Form";
import { useEffect, useState } from "react";

const ANALYSIS_IMAGE = gql`
  query ANALYSIS_IMAGE($base64String: String!, $promptType: String!) {
    analysisImage(base64String: $base64String, promptType: $promptType)
  }
`;

const AIInputView = ({ onCompleted }) => {
  const [image, setImage] = useState(null);
  const [analysisImage, analysisImageRes] = useLazyQuery(ANALYSIS_IMAGE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      console.log("data.analysisImage", data.analysisImage);
      onCompleted(data.analysisImage);
    },
    onError: (error) => {
      console.error("Error analyzing image:", error);
    },
  });

  useEffect(() => {
    // listen to paste events

    const handlePaste = (event) => {
      const clipboardData = event.clipboardData || window.clipboardData;

      // Check if the pasted data contains an image
      if (clipboardData && clipboardData.items) {
        for (let item of clipboardData.items) {
          if (item.kind === "file" && item.type.startsWith("image/")) {
            const file = item.getAsFile();
            const reader = new FileReader();

            reader.onload = (e) => {
              setImage(e.target.result); // Set the image source to display it
            };

            reader.readAsDataURL(file); // Read the file as a data URL
            break; // Exit loop after finding the first image
          }
        }
      }

      // Prevent the default paste behavior
      event.preventDefault();
    };

    document.addEventListener("paste", handlePaste);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  });

  return (
    <div>
      <div className="space-y-2 text-sm">
        {image && (
          <img src={image} alt="Pasted content" className="max-w-full h-auto" />
        )}

        <FileSelector
          title="Upload Image"
          multiple={false}
          onChange={(e) => {
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
              setImage(e.target.result); // Set the image source to display it
            };

            reader.readAsDataURL(file); // Read the file as a data URL

            e.target.value = null;
          }}
        />
      </div>

      <div className="opacity-70 text-xs">
        Upload an image here(you can just paste it if you have already copied
        it), let AI helps to get the information we need.
      </div>

      <div className="mt-4">
        <Button
          loading={analysisImageRes.loading}
          onClick={() => {
            analysisImage({
              variables: { base64String: image, promptType: "price" },
            });
          }}
          next
        >
          Process
        </Button>
      </div>

      <hr />

      <div>
        <div className="text-sm">Check the video below for how to use.</div>
        <video
          className="mt-2 w-full"
          src="https://cdn.waboba.com/public/ai-prices.mp4"
          muted
          controls
        />
      </div>
    </div>
  );
};

export default AIInputView;
